define([
	"dojo/_base/declare",
	"csi/heading/String"
], function(declare,StringRen) {

	return declare(StringRen, {
		canCopy: function(/*Context*/ctxCopy, /*Heading*/h) {
			// DE29854: Drag and fill option should be removed for Roles Node Name
			return false;
		}
	});
});